import { render } from "./LoadingProjectCard.vue?vue&type=template&id=6742a46c&scoped=true"
import script from "./LoadingProjectCard.vue?vue&type=script&lang=js"
export * from "./LoadingProjectCard.vue?vue&type=script&lang=js"

import "./LoadingProjectCard.vue?vue&type=style&index=0&id=6742a46c&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6742a46c"]])

export default __exports__